import EventBusyIcon from '@mui/icons-material/EventBusy';
import { useNavigate } from 'react-router-dom';
import { SystemScreen } from '../../components/alliance/system-screen';

/** An event code that doesn't match a published event */
export function EventNotFound() {
  // Hooks
  const navigate = useNavigate();

  return (
    <SystemScreen
      layout="inline"
      tone="neutral"
      icon={<EventBusyIcon />}
      eyebrow="Event not found"
      title="This event could not be found"
      body={<p>The link may be out of date, or the event may have ended.</p>}
      primaryAction={{
        label: 'View upcoming events',
        onClick: () => navigate('/events'),
      }}
    />
  );
}
